export type SurfaceState = 'default' | 'loading' | 'empty' | 'error' | 'offline';

export const surfaceCopy: Record<Exclude<SurfaceState, 'default'>, string> = {
  loading: '불러오는 중이에요.',
  empty: '아직 보여줄 기록이 없어요.',
  error: '지금은 불러오지 못했어요. 다시 시도해 주세요.',
  offline: '연결이 끊겼어요. 이 기기에 남은 값으로 이어서 볼 수 있어요.',
};

export function readSurfaceState(search = typeof window === 'undefined' ? '' : window.location.search): SurfaceState {
  const forced = new URLSearchParams(search).get('state');
  if (forced === 'loading' || forced === 'empty' || forced === 'error' || forced === 'offline') return forced;
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return 'offline';
  return 'default';
}

export function markCompareCompleted() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem('anjabom.compare-completed', '1');
  } catch {
    // Storage can be unavailable in a webview. A successful evidence result must still render.
  }
}

export function hasCompletedCompare() {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem('anjabom.compare-completed') === '1';
}
